import { useEffect } from "react"

import { useOrganization, useUser } from "@clerk/nextjs"

import { datadogRum } from "@/lib/datadog"

export function DatadogIdentify() {
  const { user } = useUser()
  const { organization } = useOrganization()

  const userId = user?.id
  const userEmail = user?.primaryEmailAddress?.emailAddress
  const userName = user?.fullName
  const orgId = organization?.id
  const orgSlug = organization?.slug

  useEffect(() => {
    if (!userId) {
      datadogRum.clearUser()
      return
    }

    datadogRum.setUser({
      id: userId,
      email: userEmail,
      name: userName ?? undefined,
      ...(orgId && { org_id: orgId }),
      ...(orgSlug && { org_slug: orgSlug }),
    })
  }, [userId, userEmail, userName, orgId, orgSlug])

  return null
}
